import { cn } from "@/lib/utils.ts";
import { forwardRef, PropsWithChildren } from "react";

export const H4 = forwardRef<
  HTMLHeadingElement,
  PropsWithChildren<{ className?: string }>
>(function H4({ className, children }, ref) {
  return (
    <h4 ref={ref} className={cn("scroll-m-20 text-2xl", className)}>
      {children}
    </h4>
  );
});
